import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  POST_CONFIRMED_AUTH_REQUEST: '',
  POST_CONFIRMED_AUTH_SUCCESS: '',
  POST_CONFIRMED_AUTH_FAILURE: '',

};

types = setStoreTypeValues(types, 'authConfirmed');

export default types;
